import i18next from "i18next";
import ChainedBackend from "i18next-chained-backend";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next, useTranslation } from "react-i18next";

const supportedLanguages = ["en-US", "en-GB"];

export function configurei18Next() {
  return i18next
    .use(ChainedBackend as any)
    .use(initReactI18next)
    .init({
      lng: "en-US",
      fallbackLng: "en-US",
      debug: true,
      backend: {
        backends: [
          resourcesToBackend(async (language: string, namespace: string) => {
            console.log(`importing ${language}/${namespace}.json`);
            if (!supportedLanguages.includes(language)) {
              return {};
            }
            const resource = await import(
              `./locales/${language}/${namespace}.json`
            );
            return resource.default;
          }),
        ],
      },
    });
}

export { useTranslation, i18next };
